export default (examName: string, sections: string) => {
  if (examName === 'GMAT') {
    const quantTypes = [
      { name: 'Pure Contexts', value: 100 },
      { name: 'Real Contexts', value: 100 }
    ];

    const verbalTypes = [
      { name: 'Critical Reasoning', value: 100 },
      { name: 'Reading Comprehen...', value: 100 }
    ];

    const dataInsightsTypes = [
      { name: 'Data Sufficiency', value: 100 },
      { name: 'Integrated Reasoning', value: 100 }
    ];

    if (!sections || sections === 'all') {
      return [
        { name: 'Quantitative Reasoning', data: quantTypes },
        { name: 'Verbal Reasoning', data: verbalTypes },
        { name: 'Data Insights', data: dataInsightsTypes }
      ];
    }

    let result = [];

    if (sections.indexOf('quantitative_reasoning') !== -1){
      result.push({ name: 'Quantitative Reasoning', data: quantTypes });
    }
    if (sections.indexOf('verbal_reasoning') !== -1) {
      result.push({ name: 'Verbal Reasoning', data: verbalTypes });
    }
    if (sections.indexOf('data_insights') !== -1) {
      result.push({ name: 'Data Insights', data: dataInsightsTypes });
    }

    return result;
  } else if (examName === 'GRE') {
    const mathTypes = [
      { name: 'Data Interpretation', value: 100 },
      { name: 'Multiple Answer', value: 100 },
      { name: 'Multiple Choice', value: 100 },
      { name: 'Numeric Entry', value: 100 },
      { name: 'Quantitative Comp...', value: 100 }
    ];

    const verbalTypes = [
      { name: 'Reading Comprehen...', value: 100 },
      { name: 'Sentence Equivalence', value: 100 },
      { name: 'Text Completion', value: 100 }
    ];

    if (!sections || sections === 'all') {
      return [
        { name: 'Math', data: mathTypes },
        { name: 'Verbal', data: verbalTypes }
      ];
    }

    let result = [];

    if (sections.indexOf('math') !== -1){
      result.push({ name: 'Math', data: mathTypes });
    }
    if (sections.indexOf('verbal') !== -1) {
      result.push({ name: 'Verbal', data: verbalTypes });
    }

    return result;
  } else {
    return [];
  }
};
